/**
 * @file PagePublications.tsx
 * @description Содержимое панели «Публикации» открытой страницы (phase19.16
 * Р3а; uiux-r3 §3.1; SB126): что на сайте и в черновике, «Что изменено»,
 * «Отменить правки…», последние версии и «Все версии». Общее для группы в
 * «Настройках страницы» (ПК) и шторки (до 1280). Источник — `publishing`
 * конструктора (`GET pages/:id/changes`).
 */

import { RefreshCw } from "lucide-react";

import { Button } from "../../ui/button";
import { Skeleton } from "../../ui/skeleton";
import { useBuilder } from "../builder-context";
import { PageDraftSummary } from "./PageDraftSummary";
import { PageRecentVersions } from "./PageRecentVersions";

export function PagePublications() {
  const b = useBuilder();
  const { changes, error } = b.publishing;
  if (error && !changes) {
    return (
      <div className="flex flex-col items-start gap-2">
        <p className="type-caption text-on-surface-variant">{error}</p>
        <Button variant="outline" onClick={() => void b.publishing.reload()}>
          <RefreshCw aria-hidden />
          Повторить
        </Button>
      </div>
    );
  }
  if (!changes) return <Skeleton className="h-24 rounded-xl" aria-label="Загружаем черновик страницы" />;
  return (
    <div className="flex flex-col gap-4">
      <PageDraftSummary changes={changes} />
      {changes.live ? <PageRecentVersions pageId={changes.pageId} liveVersion={changes.live.version} /> : null}
    </div>
  );
}
